import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/$dealership/conversations/$threadId")({
  staticData: {
    breadcrumb: "Thread",
  },
  component: ThreadLayout,
})

function ThreadLayout() {
  return <Outlet />
}
